import React, { useEffect, useRef, useState } from "react";
import BusinessDetailsForm from "./BusinessDetailsForm";
import AvailableForm from "./AvailableForm";
import PortfolioForm from "./PorfolioForm";
import "./SignUpForm.css";
import Logo from "../Logo/Logo";
import blueLogo from "../../assets/blueLogo.svg";
import back from "../../assets/back-arrow.svg";
import next from "../../assets/forward-arrow.svg";
import { getStates } from "../../mockApi";
import SignUpSuccessful from "./SignUpSuccessful";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const whyRegister = [
  {
    sn: 1,
    name: "Serious Clients Only",
    title: "Every client pays a small listing fee to post their event request. That means no time-wasters — only real clients who are genuinely ready to hire.",
  },
  {
    sn: 2,
    name:"Higher-Quality Leads",
    title:
      "Because clients invest upfront, they’re motivated to find vendors fast. You get access to verified, ready-to-book clients who value quality.",
  },
  {
    sn: 3,
    name: "More Wins, Less Chasing",
    title: "No more endless chats that lead nowhere. You only respond to clients with real budgets and confirmed event plans.",
  },
];


function SignUpForm() {
  const [page, setPage] = useState(0);
  const [formData, setFormData] = useState({
    businessName: "",
    stateOfResidence: "",
    registrationNumber: "",
    isBusinessRegistered: true,
    canTravel: false,
    phone: "",
    email: "",
    budget: "",
    additionalStates: [],
    instagram: "",
    website: "",
    services: [],
    availableDays: [
      "Mondays",
      "Tuesdays",
      "Wednessdays",
      "Thursdays",
      "Fridays",
    ],
    images: [],
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [margins, setMargins] = useState({
    marginLeft: 0,
    marginRight: 0,
  });
  const stepRef = useRef([]);
  const [states, setStates] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [imageErrors, setImageErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (stepRef.current.length > 0) {
      setMargins({
        marginLeft: stepRef.current[0]?.offsetWidth / 2 || 0,
        marginRight:
          stepRef.current[stepRef.current.length - 1]?.offsetWidth / 2 || 0,
      });
    }

    getStates().then((data) => {
      setStates(data.states);
    });
  }, [stepRef.current]);

  const calculateProgressBarWidth = () => {
    return ((currentStep - 1) / (FormTitles.length - 1)) * 100;
  };

  const FormTitles = ["Business Details", "Availability", "Portfolio"];

  const validateBusinessDetails = () => {
    const newErrors = {};

    if (!formData.businessName)
      newErrors.businessName = "Business name is required";

    if (formData.isBusinessRegistered && !formData.registrationNumber)
      newErrors.registrationNumber = "Registration number is required";

    const phoneRegex = /^[0-9]{10,11}$/;
    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "Invalid phone number format";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.instagram) {
      newErrors.instagram = "Instagram handle is required";
    }

    if (formData.services.length < 1) {
      newErrors.services = "Select at least one service";
    } else if (formData.services.length > 2) {
      newErrors.services = "Select a maximum of two services";
    }

    setErrors(newErrors);

    setTimeout(() => {
      setErrors({});
    }, 6000);

    return Object.keys(newErrors).length === 0;
  };

  const validatePortfolio = () => {
    const newErrors = {};

    if (!formData.images || formData?.images.length === 0) {
      newErrors.images = "Please add at least one image";
    }

    setImageErrors(newErrors);

    setTimeout(() => {
      setImageErrors({});
    }, 2000);

    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    console.log(formData);

    if (page === 0) {
      if (validateBusinessDetails()) {
        setPage((currPage) => currPage + 1);
        setCurrentStep((prevStep) => prevStep + 1);
      }
    } else if (page === FormTitles.length - 1) {
      if (validatePortfolio()) {
        setSubmitted(true);
        setPage((currPage) => currPage + 1);
        setCurrentStep((prevStep) => prevStep + 1);
        console.log(formData);
      }
    } else {
      setPage((currPage) => currPage + 1);
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevious = () => {
    setCurrentStep((prevStep) => {
      if (prevStep === 1) {
        return prevStep;
      } else {
        setPage((currPage) => currPage - 1);
        return prevStep - 1;
      }
    });
  };

  const PageDisplay = () => {
    if (submitted) {
      return <SignUpSuccessful />;
    }

    if (page === 0) {
      return (
        <BusinessDetailsForm
          formData={formData}
          setFormData={setFormData}
          states={states}
          errors={errors}
        />
      );
    } else if (page === 1) {
      return (
        <AvailableForm
          formData={formData}
          setFormData={setFormData}
          states={states}
        />
      );
    } else {
      return (
        <PortfolioForm
          formData={formData}
          setFormData={setFormData}
          imageErrors={imageErrors}
        />
      );
    }
  };

  return (

    <>
    <Helmet>
        <title>Register as a vendor.</title>
        <meta name="description" content="Join Quickplanners to reach serious clients looking for reliable event vendors. Get verified, get seen, and grow your business." />
    </Helmet>
    <div className="content">
      <section className="d-flex vendor-registeration">
        <div className="side">
          <div className="logo">
            <Logo />
          </div>

          <h2 className="sub-head">Why Vendors Love Quickplanners</h2>

          <div className="register-reason">
            <div>
               {whyRegister.map((item) => (
                <div className="reason-item d-flex gap-3" key={item.sn}>
                  <div className="reason-icon">
                    <p className="sn">{item.sn}</p>
                  </div>
                  <div className="reason-items">
                    <p className="">{item.name}</p>
                    <span className="">{item.title}</span>
                  </div>
                </div>
              ))}{" "}
            </div>
          </div>
        </div>

        <div className="main">
          <Link to="/">
            <img src={blueLogo} alt="Logo" className="blue-logo" />
          </Link>

          <h2 className="main-head">Register as a vendor</h2>
          {submitted ? (
            <p className="sub-para">Registration completed</p>
          ) : (
            <><p className="sub-para">
              Complete the form below to register as a vendor on Quickplanners.
            </p>

            <div class="warning-message">
              <p>
                <strong>Vendor approval isn’t guaranteed.</strong> <div style={{marginTop: "8px"}} />
                Each application is reviewed and verified — only vendors who meet our standards are approved.</p>
            </div>
            </>
            
          )}

          <div className="stepper">
            {FormTitles.map((title, index) => (
              <div
                key={title}
                ref={(el) => (stepRef.current[index] = el)}
                className={`step ${
                  currentStep > index + 1 || isComplete ? "complete" : ""
                } ${currentStep === index + 1 ? "active" : ""}`}
              >
                <div className="step-number">
                  {currentStep > index + 1 || isComplete ? (
                    <span>&#10003;</span>
                  ) : currentStep === index + 1 ? (
                    <span>&#x3f;</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ))}

            <div
              className="progress-bar"
              style={{
                width: `calc(100% - ${
                  margins.marginLeft + margins.marginRight
                }px)`,
                marginLeft: margins.marginLeft,
                marginRight: margins.marginRight,
              }}
            >
              <div
                className="progress"
                style={{ width: `${calculateProgressBarWidth()}%` }}
              ></div>
            </div>
          </div>

          {/* Form details */}

          <div className="">
            <div className="progressbar">
              <div
                style={{
                  width: page === 0 ? "33.3%" : page === 1 ? "66.6%" : "100%",
                }}
              ></div>
            </div>
            <div className="form-container">
              <div className="body">{PageDisplay()}</div>
              <div className="">
                <div className="d-flex justify-content-between align-items-center stepper-nav">
                  {currentStep > 1 && !submitted && (
                    <button
                      className="step-btn btn-ghost d-flex align-items-center gap-3"
                      onClick={handlePrevious}
                    >
                      <span>
                        <img src={back} alt="previous step arrow" />
                      </span>
                      Back
                    </button>
                  )}
                  <div></div>

                  {submitted && (
                    <Link to="/">
                      <button
                        className={`step-btn btn-full d-flex align-items-center gap-3 complete`}
                        onClick={() => handleNext()}
                      >
                        Done
                      </button>
                    </Link>
                  )}
                  {!isComplete && !submitted && (
                    <>
                      {!submitted && currentStep === FormTitles.length ? (
                        <>
                          <button
                            className={`step-btn btn-full d-flex align-items-center gap-3 ${
                              currentStep === FormTitles.length
                                ? "complete"
                                : ""
                            }`}
                            onClick={handleNext}
                          >
                            {!loading && "Submit"}{" "}
                            {loading && (
                              <div
                                className="spinner-border text-light"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            )}
                          </button>
                        </>
                      ) : (
                        <button
                          className={`step-btn btn-full d-flex align-items-center gap-3 ${
                            currentStep === FormTitles.length ? "complete" : ""
                          }`}
                          onClick={() => handleNext()}
                        >
                          {" "}
                          Next{" "}
                          <span>
                            <img src={next} alt="next step arrow" />
                          </span>{" "}
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
    
  );
}

export default SignUpForm;
